export interface IAllocationPlanParams {
    from: number | null;
    destinationId: string;
    to: number | null;
}

export const allocationPlanParamsInit: IAllocationPlanParams = {
    from: 0,
    destinationId: "",
    to: 0,
};
